import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, toHandlers as _toHandlers, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "page-grid-wrapper"
};
import { reactive, watch, ref, provide, computed, useSlots, nextTick } from 'vue';
import { useQueryProxy, useDeleteProxy } from './use';
import { MgListPageLayout } from '../mg-list-page-layout';
import MgActionToolbar from './mg-action-toolbar';
import { useComponentModal, modal, createEditorForm } from '@/share/components';
export default {
  __name: 'mg-list-page',
  props: {
    id: {
      type: String
    },
    // 使用该值，用于保存列配置
    toolbar: {
      type: Array,
      default: () => ['add', 'update', 'delete', 'export', 'print', 'custom', 'refresh']
    },
    columns: {
      type: Array,
      default: () => []
    },
    titleField: {
      type: String,
      default: 'name'
    },
    // 标题字段
    keyField: {
      type: String,
      default: 'id'
    },
    // 主键字段
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    queryFields: {
      type: Array,
      default: () => []
    },
    searchFields: {
      type: Array,
      default: () => []
    },
    filterFields: {
      type: Array,
      default: () => []
    },
    stripe: {
      type: Boolean,
      default: true
    },
    // 是否使用斑马行样式，tree模式不支持
    gridProps: {
      type: Object,
      default: () => ({})
    },
    remoteSort: {
      type: Boolean,
      default: false
    },
    // 是否使用远程排序
    enablePager: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 50
    },
    currentPage: {
      type: Number,
      default: 1
    },
    beforeSelectRow: {
      type: Function
    },
    // 选择行前，返回false,禁止选择
    leftPanel: {
      type: Object,
      default: () => ({
        width: '200px',
        showAction: true
      })
    },
    rightPanel: {
      type: Object,
      default: () => ({
        width: '200px',
        showAction: true
      })
    },
    contextmenu: {
      type: Array,
      default: () => []
    },
    editRow: {
      type: Function,
      default: undefined
    },
    // 编辑数据行, 返回非false刷新表格
    // 数据行编辑器配置
    editConfig: {
      type: Object,
      default: () => ({
        save: '',
        // ({ id, data}) => {} 数据保存接口
        query: '',
        // ({ id }) => data 数据查询接口
        modifyTitle: () => `修改数据`,
        // 编辑器标题
        appendTitle: () => '添加数据',
        // 新增加标题
        queryParams: undefined,
        // 查询附带参数
        afterQuery: undefined,
        // ({ params, data }) => data, // 查询后的数据处理函数
        beforeSave: undefined,
        // ({formData}) => formData||false // 编辑前,返回false,取消保存
        afterSave: undefined,
        // ({formData, result}) => formData||false, 保存后// 返回false取消刷新
        items: [],
        rules: {},
        data: {}
      })
    },
    // 编辑器属性
    // 数据查询参数
    queryConfig: {
      type: Object,
      default: () => ({
        api: '',
        // 查询接口名称，或函数
        sortFormater: undefined,
        // (fields) => fields
        params: undefined,
        // ({ currentPage, pageSize, params }) => ({ currentPage, pageSize, params }), // 查询附带的参数，可为object或返回参数的function
        beforeQuery: undefined,
        // (params) => true, // 返回false 取消查询
        pagerFields: {
          currentPage: 'pi',
          pageSize: 'ps'
        },
        respFields: {
          rows: 'rows',
          currentPage: 'pi',
          pageSize: 'ps',
          total: 'total'
        },
        // 返回数据字段配置
        after: undefined // ({ rows, total, currentPage, pageSize }) => ({ rows, total, currentPage, pageSize }) // 查询后的数据处理
      })
    },
    // 参数
    deleteConfig: {
      type: Object,
      default: () => ({
        api: '',
        // 接口名称或函数
        params: undefined,
        // ({ row, id }) => ({ row, id }), // 删除需要的参数
        after: undefined // ({id, params}) => {} 删除成功后的回调
      })
    },
    deleteRow: {
      type: Function
    },
    editor: {
      type: Object
    },
    // 数据编辑器
    editorExtParams: {
      type: [Object, Function]
    },
    editorModalOptions: {
      type: Object,
      default: () => ({
        width: '50%',
        resize: false,
        fullscreen: false,
        showMaximize: false,
        showMinimize: false,
        modifyTitle: () => '修改数据',
        appendTitle: () => '添加数据'
      })
    },
    // 编辑器模式窗口配置
    rowClassName: {
      type: [String, Function]
    },
    rowStyle: {
      type: [String, Function]
    },
    cellClassName: {
      type: [String, Function]
    },
    cellStyle: {
      type: [String, Function]
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    footerData: {
      type: Object,
      default: () => ({})
    },
    footerRowClassName: {
      type: [String, Function]
    },
    footerRowStyle: {
      type: [String, Function]
    },
    footerCellClassName: {
      type: [String, Function]
    },
    footerCellStyle: {
      type: [String, Function]
    },
    showOverflow: {
      type: [Boolean, String],
      default: false,
      validator: value => typeof value === 'boolean' || ['ellipsis', 'title', 'tooltip', ''].includes(value)
    },
    showHeaderOverflow: {
      type: [Boolean, String],
      default: false,
      validator: value => typeof value === 'boolean' || ['ellipsis', 'title', 'tooltip', ''].includes(value)
    },
    showFooterOverflow: {
      type: [Boolean, String],
      default: false,
      validator: value => typeof value === 'boolean' || ['ellipsis', 'title', 'tooltip', ''].includes(value)
    }
  },
  emits: ['refresh', 'pageChange', 'radioChange', 'checkboxChange', 'queryParamChange', 'applyFilter', 'cancelFilter', 'search', 'resetSearch', 'selectChange', 'rowClick', 'rowDblClick', 'cellClick', 'cellDblClick', 'cellMouseenter', 'cellMouseleave', 'rowMouseenter', 'rowMouseleave', 'cellMenu', 'rowMenu', 'afterLoadData', 'tableMenuClick', 'headerCellClick', 'deleteRow', 'editRow', 'sortChange', 'toolbarItemClick', 'toolbarItemDropdownClick', 'afterEdit', 'afterRemove'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      openEditor,
      openComponent
    } = useComponentModal();
    const listPageRef = ref();
    const state = reactive({
      mouseEnterRowIndex: -1,
      currentRow: null // 当前行
    });
    const emit = __emit;
    const props = __props;
    const queryProxyProps = reactive({
      enablePager: props.enablePager,
      currentPage: props.currentPage,
      pageSize: props.pageSize,
      total: props.total,
      rows: props.rows
    });
    const {
      enableQueryProxy,
      loading,
      rows,
      total,
      enablePager,
      currentPage,
      pageSize,
      queryParams,
      updateQueryConfig,
      loadData,
      reloadData,
      refresh,
      remoteSortData,
      updateQueryParams,
      loadPage
    } = useQueryProxy(queryProxyProps, {
      onAfterLoadData({
        params,
        rows,
        total,
        currentPage,
        pageSize
      }) {
        emit('afterLoadData', {
          params,
          rows,
          total,
          currentPage,
          pageSize
        });
      }
    });
    const gridLoading = computed(() => {
      return loading.value || props.loading;
    });
    const handleBeforeSelectRow = ({
      row
    }) => {
      if (!!props.beforeSelectRow && typeof props.beforeSelectRow === 'function') {
        return props.beforeSelectRow({
          row
        });
      }
      return true;
    };
    const gridRef = ref();
    const gridOptions = reactive({
      id: props.id,
      border: true,
      showOverflow: props.showOverflow,
      // ellipsis,title, tooltip
      height: '100%',
      showHeader: true,
      stripe: props.stripe,
      align: 'left',
      // 所有列对齐方式
      headerAlign: 'center',
      // 所有列头对齐方式
      showHeaderOverflow: props.showHeaderOverflow,
      formConfig: {
        enabled: true
      },
      columnConfig: {
        drag: true,
        resizable: true
      },
      customConfig: {
        storage: !!props.id // 保存配置
        // restoreStore ({ id }) {}, // 用于远程保存配置
        // updateStore ({ id }) {}, // 用于远程保存配置
      },
      sortConfig: {
        multiple: true,
        // 多字段排序
        remote: props.remoteSort
      },
      rowConfig: {
        isCurrent: true,
        // 高亮行
        isHover: true,
        // 悬停高亮
        keyField: props.keyField // 数据唯一字段名
      },
      currentRowConfig: {
        beforeSelectMethod: handleBeforeSelectRow
      },
      columns: [],
      printConfig: {},
      exportConfig: {},
      tooltipConfig: undefined,
      menuConfig: {
        enabled: true,
        header: {
          disabled: false
        },
        body: {
          options: []
        },
        footer: {
          disabled: true
        }
      },
      ...props.gridProps
    });
    const pagerOptions = reactive({
      align: 'center',
      layouts: ['Home', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'End', 'Sizes', 'FullJump', 'Total']
    });
    const pagerConfig = computed(() => {
      if (!enablePager.value) {
        return undefined;
      }
      return {
        ...pagerOptions,
        enablePager: true,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        total: total.value
      };
    });
    const openEditorModal = async (title, id, params = {}, modalOptions = {}) => {
      let editorForm = null;
      const currentRow = getCurrentRow();
      const {
        modifyTitle,
        appendTitle,
        ...modalProps
      } = props.editorModalOptions || {};
      if (id) {
        if (!!modifyTitle && typeof modifyTitle === 'function') {
          title = modifyTitle({
            id,
            row: currentRow,
            ...params
          });
        } else if (!!modifyTitle && typeof modifyTitle === 'string') {
          title = modifyTitle;
        }
      } else {
        if (!!appendTitle && typeof appendTitle === 'function') {
          title = appendTitle();
        } else if (!!appendTitle && typeof appendTitle === 'string') {
          title = appendTitle;
        }
      }
      if (editConfigMode.value === 'config') {
        if (id) {
          // modify
          if (!!props.editConfig.modifyTitle && typeof props.editConfig.modifyTitle === 'function') {
            title = props.editConfig.modifyTitle({
              id,
              row: currentRow,
              ...params
            });
          } else if (!!props.editConfig.modifyTitle && typeof props.editConfig.modifyTitle === 'string') {
            title = props.editConfig.modifyTitle;
          }
        } else {
          // append
          if (!!props.editConfig.appendTitle && typeof props.editConfig.appendTitle === 'function') {
            title = props.editConfig.appendTitle();
          } else if (!!props.editConfig.appendTitle && typeof props.editConfig.appendTitle === 'string') {
            title = props.editConfig.appendTitle;
          }
        }
        editorForm = createEditorForm(props.editConfig);
      } else if (editConfigMode.value === 'editor') {
        editorForm = props.editor;
      }
      if (!editorForm) {
        modal.notification.warning('未设置编辑器，不能编辑数据');
        return Promise.resolve(false);
      }
      const extraParams = {};
      if (props.editorExtParams) {
        if (typeof props.editorExtParams === 'function') {
          const tmp = await props.editorExtParams(id);
          if (tmp && typeof tmp === 'object') {
            Object.assign(extraParams, tmp);
          }
        } else if (typeof props.editorExtParams === 'object') {
          Object.assign(extraParams, props.editorExtParams);
        }
      }
      const res = await openEditor(title, editorForm, {
        ...extraParams,
        ...params
      }, {
        resize: false,
        showMaximize: false,
        showMinimize: false,
        ...modalProps,
        ...modalOptions
      });
      if (res) {
        await refresh();
        emit('afterEdit', res);
      }
      return Promise.resolve(res);
    };

    // 显示新增加数据编辑器
    /**
     * 显示添加窗口
     * @param params {Object}
     * @param modalOptions {Object}
     * @returns {Promise<Awaited<*|Promise<Awaited<*>>>|Awaited<boolean>>}
     */
    const showAppendEditor = async (params = {}, modalOptions = {}) => {
      return openEditorModal('添加数据', '', params, modalOptions);
    };

    // 显示修改数据对话框
    const showUpdateEditor = async (row = {}, modalOptions = {}) => {
      let title = row[props.titleField] || row.title;
      if (!title) {
        title = '编辑数据';
      } else {
        title = `编辑[${title}]`;
      }
      const {
        [gridOptions.rowConfig.keyField]: id = ''
      } = row || {};
      if (!id) {
        modal.message.warning('请选择要修改的数据行');
        return Promise.resolve(false);
      }
      return openEditorModal(title, id, row, modalOptions);
    };
    const showCurrentUpdateEditor = async () => {
      const row = getCurrentRow();
      if (!row) {
        modal.alert.warning('提示', '请选择要修改的行');
        return Promise.resolve(false);
      }
      return showUpdateEditor(getCurrentRow());
    };
    const emitRowMouseenter = (row, rowIndex, $event) => {
      if (rowIndex !== state.mouseEnterRowIndex) {
        state.mouseEnterRowIndex = rowIndex;
        emit('rowMouseenter', {
          row,
          rowIndex,
          $event
        });
      }
    };
    const emitRowMouseleave = (row, rowIndex, $event) => {
      if (rowIndex === state.mouseEnterRowIndex) {
        state.mouseEnterRowIndex = -1;
        emit('rowMouseleave', {
          row,
          rowIndex,
          $event
        });
      }
    };
    const setSort = (field, order, refresh) => {
      !!gridRef.value && gridRef.value.setSort({
        field,
        order
      }, refresh); // 最后一个参数为true时更新表本数据
    };

    // getTable 获取表格实例
    const getTable = () => {
      return gridRef.value;
    };

    // 列type=radio时获取选择的行数据
    const getRadioRow = (isFull = true) => {
      if (!gridRef.value) return null;
      return gridRef.value.getRadioRecord(isFull);
    };

    // 列type=checkbox时，获取钩选的数据行列表
    const getCheckboxRows = (isFull = true) => {
      if (!gridRef.value) return [];
      return gridRef.value.getCheckboxRecords(isFull);
    };

    // 根据行数据获取数据id
    const getRowId = row => {
      if (gridRef.value) {
        return gridRef.value.getRowid(row);
      }
      return '';
    };

    // getRowById 根据id获取行数据
    const getRowById = id => {
      if (gridRef.value) {
        return gridRef.value.getRowById(id);
      }
      return null;
    };

    // 获取序列的列列表信息, onlyField=true时只返回字段名和排序方式
    const getSortColumns = (onlyField = true) => {
      let columns = [];
      if (gridRef.value) {
        columns = gridRef.value.getSortColumns();
        if (onlyField) {
          return columns.map(item => ({
            field: item.field,
            order: item.order
          }));
        }
        return columns;
      }
      return [];
    };
    const doFieldSort = (field, order) => {
      if (props.remoteSort) {
        // 使用远程,emit排序事件
        setSort(field, order, false);
        const sortColumns = getSortColumns(false);
        emit('sortChange', sortColumns);
        nextTick(() => {
          remoteSortData(sortColumns.map(item => ({
            field: item.field,
            order: item.order
          })));
        });
      } else {
        // 本地排序
        setSort(field, order, true);
      }
    };
    const editConfigMode = computed(() => {
      if (!!props.editConfig && (!!props.editConfig.query || !!props.editConfig.save)) {
        return 'config';
      } else if (!!props.editor && typeof props.editor === 'object') {
        return 'editor';
      }
      return 'none';
    });
    const editorIsConfig = computed(() => {
      const mode = editConfigMode.value;
      return ['config', 'editor'].includes(mode);
    });
    const gridEvents = {
      'headerCellClick'({
        column,
        columnIndex,
        triggerResizable,
        triggerSort,
        triggerFilter,
        $event
      }) {
        if (!triggerResizable) {
          if (column.sortable) {
            let nextOrder = '';
            switch (column.order) {
              case 'asc':
                nextOrder = 'desc';
                break;
              case 'desc':
                nextOrder = '';
                break;
              case '':
                nextOrder = 'asc';
                break;
            }
            doFieldSort(column.field, nextOrder);
          }
        }
        emit('headerCellClick', {
          column,
          columnIndex,
          triggerResizable,
          triggerSort,
          triggerFilter,
          $event
        });
      },
      pageChange: ({
        pageSize: ps,
        currentPage: pi
      }) => {
        emit('pageChange', {
          pageSize,
          currentPage,
          params: queryParams.value
        });
        if (enableQueryProxy.value) {
          loadPage(pi, ps);
        }
      },
      'sortChange'({
        sortList
      }) {
        if (!props.remoteSort) {
          // 只有远程排序时，才触发sortChange事件
          emit('sortChange', sortList);
        } else if (enableQueryProxy.value) {
          // 远程程序
          remoteSortData(sortList.map(item => ({
            field: item.field,
            order: item.order
          })));
        }
      },
      'currentRowChange'({
        newValue,
        oldValue,
        row,
        $event
      }) {
        state.currentRow = row;
        emit('selectChange', {
          oldValue,
          newValue,
          row,
          $event
        });
      },
      'radioChange'({
        newValue,
        oldValue,
        row,
        rowIndex,
        column,
        columnIndex,
        $event
      }) {
        emit('radioChange', {
          newValue,
          oldValue,
          rowIndex,
          row,
          column,
          columnIndex,
          $event
        });
      },
      'checkboxChange'({
        checked,
        row,
        rowIndex,
        columnIndex,
        column,
        $event
      }) {
        emit('checkboxChange', {
          checked,
          row,
          rowIndex,
          column,
          columnIndex,
          $event
        });
      },
      'cellMouseenter'({
        row,
        rowIndex,
        column,
        columnIndex,
        $event
      }) {
        emit('cellMouseenter', {
          row,
          rowIndex,
          column,
          columnIndex,
          $event
        });
        emitRowMouseenter(row, rowIndex, $event);
      },
      'cellMouseleave'({
        row,
        rowIndex,
        column,
        columnIndex,
        $event
      }) {
        emitRowMouseleave(row, rowIndex, $event);
        emit('cellMouseleave', {
          row,
          rowIndex,
          column,
          columnIndex,
          $event
        });
      },
      menuClick({
        $event,
        menu,
        type,
        row,
        rowIndex,
        column,
        columnIndex
      }) {
        emit('tableMenuClick', {
          $event,
          menu,
          type,
          row,
          rowIndex,
          column,
          columnIndex
        });
      },
      'cellMenu'({
        rowIndex,
        row,
        columnIndex,
        column,
        $event
      }) {
        emit('cellMenu', {
          rowIndex,
          row,
          columnIndex,
          column,
          $event
        });
        emit('rowMenu', {
          rowIndex,
          row,
          $event
        });
      },
      'cellClick'({
        row,
        rowIndex,
        columnIndex,
        column,
        $event
      }) {
        state.currentRow = row;
        emit('cellClick', {
          row,
          rowIndex,
          columnIndex,
          column
        });
        emit('rowClick', {
          row,
          rowIndex,
          $event
        });
      },
      'cellDblclick'({
        row,
        rowIndex,
        columnIndex,
        column,
        $event
      }) {
        emit('cellDblClick', {
          row,
          rowIndex,
          columnIndex,
          column,
          $event
        });
        emit('rowDblClick', {
          row,
          rowIndex,
          $event
        });
        if (editorIsConfig.value || typeof props.editRow === 'function') {
          editRow(row);
        }
      }
    };
    const methods = {
      openEditor,
      openComponent,
      openExport() {
        !!gridRef.value && gridRef.value.openExport();
      },
      openPrint() {
        !!gridRef.value && gridRef.value.openPrint();
      },
      openCustom() {
        !!gridRef.value && gridRef.value.openCustom();
      },
      clear() {
        rows.value = [];
        total.value = 0;
      }
    };
    const handleRefresh = () => {
      refresh();
    };
    const handleExport = () => {
      methods.openExport();
    };
    const handlePrint = () => {
      methods.openPrint();
    };
    const handleOpenCustom = () => {
      methods.openCustom();
    };
    const listPageEvents = {
      search(params) {
        const margeParams = {
          ...queryParams.value,
          ...params
        };
        queryParams.value = margeParams;
        emit('search', margeParams);
        emit('queryParamChange', margeParams);
        reloadData(queryParams.value);
      },
      resetSearch() {
        queryParams.value = {};
        emit('resetSearch');
        emit('queryParamChange', {});
        reloadData();
      },
      cancelFilter() {
        emit('cancelFilter');
      },
      applyFilter(data) {
        queryParams.value = {
          ...data
        };
        emit('applyFilter', data);
        emit('queryParamChange', queryParams.value);
        reloadData(queryParams.value);
      }
    };
    const slots = useSlots();
    const hasSearchOrFilterProps = computed(() => {
      return Array.isArray(props.searchFields) && props.searchFields.length > 0 || Array.isArray(props.filterFields) && props.filterFields.length > 0 || !!slots['search-bar'];
    });
    watch(() => props.id, val => {
      gridOptions.id = val;
      gridOptions.customConfig.storage = !!val;
    }, {
      immediate: true
    });
    watch(() => props.columns, val => {
      Object.assign(gridOptions.columns, val);
    }, {
      immediate: true,
      deep: true
    });
    watch(() => [props.gridProps, props.keyField], attr => {
      const {
        options,
        keyField
      } = attr;
      gridOptions.rowConfig.keyField = keyField;
      Object.assign(gridOptions, options);
    });
    watch(() => props.queryConfig, val => {
      updateQueryConfig(val);
    }, {
      deep: true,
      immediate: true
    });
    watch(() => [props.data, props.total], attrs => {
      const [arr, d1] = attrs;
      rows.value = arr;
      total.value = d1;
    }, {
      deep: true,
      immediate: true
    });
    watch(() => [props.enablePager, props.pageSize, props.currentPage, props.total], val => {
      const [b, ps = 50, pi = 1, c = 0] = val || [];
      pagerOptions.enablePager = b;
      currentPage.value = pi;
      pageSize.value = ps;
      total.value = c;
    }, {
      immediate: true
    });
    watch(() => props.contextmenu, val => {
      if (!val || !Array.isArray(val) || val.length === 0) {
        gridOptions.menuConfig.body.disabled = true;
      } else {
        console.log('menu items:', val);
        gridOptions.menuConfig.body.options = val;
      }
    }, {
      immediate: true,
      deep: true
    });
    const getCurrentRow = () => {
      let row = state.currentRow;
      if (gridRef.value) {
        row = gridRef.value.getCurrentRecord(true);
      }
      return row || {};
    };
    const getCurrentId = () => {
      const {
        rowConfig: {
          keyField
        } = {}
      } = gridOptions;
      const {
        [keyField || 'id']: id = ''
      } = getCurrentRow();
      return id;
    };
    const deleteRowProxy = useDeleteProxy(props);

    // 删除当前数据行
    const deleteCurrentRow = async () => {
      const row = getCurrentRow();
      const id = getCurrentId();
      if (!id) {
        modal.alert.warning('提示', '未选择要删除的行');
        return Promise.resolve(false);
      }
      const confirm = await modal.confirm('删除确认', '您确认要删除当前行吗，删除后不可恢复', {
        confirmText: '确认删除',
        cancelText: '放弃删除'
      });
      if (!confirm) return Promise.resolve(false);
      emit('deleteRow', {
        row,
        id
      });
      const res = await deleteRowProxy({
        row,
        id
      });
      if (!res) {
        return Promise.resolve(false);
      }
      modal.notification.success('删除数据成功');
      await refresh();
      emit('afterRemove', {
        row
      });
      return Promise.resolve(true);
    };

    // 编辑当前数据行
    const editCurrentRow = async () => {
      const id = getCurrentId();
      if (!id) {
        modal.alert.warning('提示', '请选择要编辑的行');
        return Promise.resolve(false);
      }
      const rowData = getCurrentRow();
      if (editorIsConfig.value) {
        await showUpdateEditor(rowData);
        return Promise.resolve(true);
      }
      if (typeof props.editRow === 'function') {
        const res = await props.editRow(rowData);
        if (!res) return Promise.resolve(false);
        await refresh();
        return Promise.resolve(true);
      } else {
        emit('editRow', rowData);
      }
    };
    const setCurrentRow = row => {
      !!gridRef.value && gridRef.value.setCurrentRow(row);
      state.currentRow = row;
    };
    const deleteRow = async row => {
      setCurrentRow(row);
      return deleteCurrentRow();
    };
    const editRow = async row => {
      setCurrentRow(row);
      return editCurrentRow();
    };
    const handleToolbarItemClick = ({
      item,
      $event
    }) => {
      const {
        name = ''
      } = item || {};
      switch (name) {
        case 'add':
          showAppendEditor();
          break;
        case 'update':
          showCurrentUpdateEditor();
          break;
        case 'delete':
          deleteCurrentRow();
          break;
        case 'refresh':
          refresh();
          break;
        case 'print':
          methods.openPrint();
          break;
        case 'custom':
          methods.openCustom();
          break;
        case 'export':
          methods.openExport();
          break;
        default:
          emit('toolbarItemClick', {
            item,
            $event,
            methods
          });
      }
    };
    const handleToolbarItemDropdownClick = params => {
      emit('toolbarItemDropdownClick', {
        ...params,
        methods
      });
    };

    /**
     * 打开自定义编辑器模式窗口
     * @param title
     * @param editor
     * @param params
     * @param modalOptions
     * @returns {Promise<Awaited<boolean>|Awaited<*|* extends (object & {then(onfulfilled: infer F, ...args: infer _): any}) ? (F extends ((value: infer V, ...args: infer _) => any) ? Awaited<V> : never) : *|boolean>>}
     */
    const openCustomEditor = async (title, editor, params = {}, modalOptions = {}) => {
      const row = getCurrentRow();
      const res = await openEditor(title, editor, {
        row,
        ...params
      }, {
        ...modalOptions
      });
      if (!res) return Promise.resolve(false);
      await refresh();
      return Promise.resolve(res);
    };
    const publicMethods = Object.assign({}, methods, {
      updateQueryParams,
      loadPage,
      refresh,
      // 保留原来的参数
      loadData,
      // 按提供的参数加载数据
      reloadData,
      // 重新加载数据
      // 获取表格数据
      'getData'() {
        return rows.value;
      },
      getCurrentRow,
      getCurrentId,
      deleteCurrentRow,
      deleteRow,
      editCurrentRow,
      editRow,
      // 打开配置的编辑器
      openEditorModal,
      // 打开自定义编辑器
      openCustomEditor,
      setCurrentRow,
      getTable,
      getRowId,
      getRowById,
      getRadioRow,
      getCheckboxRows,
      getSortColumns,
      remoteSortData,
      setSort,
      showAppendEditor,
      showCurrentUpdateEditor,
      showUpdateEditor,
      isSupported() {
        return true;
      },
      doSearch() {
        !!listPageRef.value && listPageRef.value.doSearch();
      }
    });
    __expose(publicMethods);
    provide('$list-page', publicMethods);
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      return _openBlock(), _createBlock(_unref(MgListPageLayout), _mergeProps({
        ref_key: "listPageRef",
        ref: listPageRef,
        "show-toolbar": !!__props.toolbar && __props.toolbar.length > 0 || !!_ctx.$slots['toolbar-bar'],
        "show-searchbar": hasSearchOrFilterProps.value,
        "left-panel": __props.leftPanel,
        "right-panel": __props.rightPanel,
        "show-left-panel": !!_ctx.$slots['left-panel'],
        "show-right-panel": !!_ctx.$slots['right-panel'],
        "filter-fields": __props.filterFields,
        "search-fields": __props.searchFields
      }, _toHandlers(listPageEvents)), {
        "toolbar-items": _withCtx(() => [_renderSlot(_ctx.$slots, "toolbar-bar", {}, () => [_createVNode(_unref(MgActionToolbar), {
          items: __props.toolbar,
          onItemClick: handleToolbarItemClick,
          onItemDropdownClick: handleToolbarItemDropdownClick
        }, null, 8, ["items"])])]),
        "toolbar-buttons": _withCtx(() => [_renderSlot(_ctx.$slots, "toolbar-buttons"), _createVNode(_component_vxe_button, {
          circle: "",
          icon: "vxe-icon-refresh",
          onClick: handleRefresh
        }), _createVNode(_component_vxe_button, {
          circle: "",
          icon: "vxe-table-icon-download",
          onClick: handleExport
        }), _createVNode(_component_vxe_button, {
          circle: "",
          icon: "vxe-table-icon-print",
          onClick: handlePrint
        }), _createVNode(_component_vxe_button, {
          circle: "",
          icon: "vxe-table-icon-custom-column",
          onClick: handleOpenCustom
        })]),
        "left-panel": _withCtx(() => [_renderSlot(_ctx.$slots, "left-panel")]),
        "right-panel": _withCtx(() => [_renderSlot(_ctx.$slots, "right-panel")]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "gridRef",
          ref: gridRef
        }, gridOptions, {
          loading: gridLoading.value,
          data: _unref(rows),
          "show-footer": __props.showFooter,
          "row-class-name": __props.rowClassName,
          "row-style": __props.rowStyle,
          "cell-class-name": __props.cellClassName,
          "cell-style": __props.cellStyle,
          "footer-row-class-name": __props.footerRowClassName,
          "footer-cell-class-name": __props.footerCellClassName,
          "footer-cell-style": __props.footerCellStyle,
          "show-header-overflow": __props.showHeaderOverflow,
          "show-overflow": __props.showOverflow,
          showHeaderOverflow: __props.showHeaderOverflow,
          "show-footer-overflow": __props.showFooterOverflow,
          "pager-config": pagerConfig.value
        }, _toHandlers(gridEvents)), _createSlots({
          _: 2
        }, [_renderList(Object.keys(_ctx.$slots), key => {
          return {
            name: key,
            fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
              key: key
            }, scope))])
          };
        })]), 1040, ["loading", "data", "show-footer", "row-class-name", "row-style", "cell-class-name", "cell-style", "footer-row-class-name", "footer-cell-class-name", "footer-cell-style", "show-header-overflow", "show-overflow", "showHeaderOverflow", "show-footer-overflow", "pager-config"])])]),
        _: 3
      }, 16, ["show-toolbar", "show-searchbar", "left-panel", "right-panel", "show-left-panel", "show-right-panel", "filter-fields", "search-fields"]);
    };
  }
};